if (!process.env.SSR) {
  require('intersection-observer-polyfill/index.global'); //eslint-disable-line
}

if (typeof window === 'undefined') {
  // 兼容 ssr 时，window 为 undefined 导致报错的情况
  global.window = {};
}

export * from './ComponentActionHandler';
export * from './HotAreaActionHandler';
